<template>
  <!-- EVENT LIST -->
  <BaseModal ref="baseModalRef" :title="'Eventos'" modal-id="events" :is-visible="true" @close="closeDialog"
    @minimize="$emit('minimize', 'events')" @restore="$emit('restore', 'events')">
    <div id="buscador2" class="form">
      <div class="container-fluid">
        <div class="form events-window">
          <h5 class="col-3 ml-0">
            <div class="filters-show" @click="toggleFilters" style="cursor: pointer">
              <i :class="showFilters ? 'bi bi-caret-up-fill' : 'bi bi-caret-down-fill'"></i>
              <i class="bi bi-funnel"></i> Filtrar
            </div>
          </h5>

          <div class="col-9 align-end no-padding">
            <!-- Generico Fechas -->
            <select class="form-select select-tiempo form-select-sm" aria-label="Default select example"
              @change="handleGenericDateChange">
              <option selected>Siempre</option>
              <option value="1">Hoy</option>
              <option value="2">Este mes</option>
              <option value="3">Este año</option>
              <option value="4">Ultimos 7 dias</option>
              <option value="5">Ultimos 15 dias</option>
              <option value="6">Ultimos 30 dias</option>
            </select>
            <!-- Botones Mostrar/Ocultar -->
            <button class="btn btn-secondary btn-sm fltr-btn" @click="toggleAll(1)">
              <i class="bi bi-eye"></i> Mostrar Todos
            </button>
            <button class="btn btn-secondary btn-sm fltr-btn" @click="toggleAll(0)">
              <i class="bi bi-eye-slash"></i> Ocultar Todos
            </button>
          </div>

          <!-- INICIO FILTROS -->
          <div v-if="showFilters" class="row filter-box">
            <div class="col-3 col-6-small">
              <!-- DESCARTADOS -->
              <div class="filter-group">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" id="descartados" />
                  <label class="form-check-label" for="flexCheckDefault">
                    Mostrar DESCARTADOS
                  </label>
                </div>
              </div>
              <!-- TIPO -->
              <div class="filter-group">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" id="type" v-model="filters.showType"
                    @change="callApi" />
                  <label class="form-check-label" for="flexCheckDefault"> Tipo </label>
                </div>
                <div :hidden="!filters.showType" class="active-filter">
                  <select v-model="filters.type" @change="callApi" class="form-control">
                    <option class="form-select form-select-sm" v-for="tipo in eventTypes" :key="tipo.event_type_id"
                      :value="tipo.event_type">
                      {{ tipo.event_type }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-3 col-6-small">
              <!-- OCULTOS -->
              <div class="filter-group">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="ocultos" v-model="filters.visible"
                    @change="callApi" true-value="0" false-value="1" />
                  <label class="form-check-label" for="flexCheckDefault"> Mostrar OCULTOS </label>
                </div>
              </div>
              <!-- ESTADO -->
              <div class="filter-group">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" id="state" v-model="filters.showState"
                    @change="callApi" />
                  <label class="form-check-label" for="flexCheckDefault"> Estado </label>
                </div>
                <div :hidden="!filters.showState" class="active-filter">
                  <select class="form-select form-select-sm" aria-label="Default select example" v-model="filters.state"
                    @change="callApi">
                    <option value="ACTIVO">ACTIVO</option>
                    <option value="ARCHIVADO">ARCHIVADO</option>
                    <option value="DESCARTADO">DESCARTADO</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-3 col-6-small">
              <!-- FECHA DESDE -->
              <div class="filter-group">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" id="showStartDate"
                    v-model="filters.showStartDate" @change="callApi" />
                  <label class="form-check-label" for="flexCheckDefault"> Desde </label>
                </div>
                <div v-if="filters.showStartDate" class="active-filter">
                  <input type="date" v-model="filters.start_date" @change="callApi" class="form-control" />
                </div>
              </div>
              <!-- ALCANCE -->
              <div class="filter-group">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                    v-model="filters.showScope" @change="callApi" />
                  <label class="form-check-label" for="flexCheckDefault"> Alcance </label>
                </div>
                <div :hidden="!filters.showScope" class="active-filter">
                  <select class="form-select form-select-sm" aria-label="Default select example" v-model="filters.scope"
                    @change="callApi">
                    <option value="REPORTADO">REPORTADO</option>
                    <option value="COMUN">COMUN</option>
                    <option value="LOCAL">LOCAL</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-3 col-6-small">
              <!-- FECHA HASTA -->
              <div class="filter-group">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" id="showEndDate"
                    v-model="filters.showEndDate" @change="callApi" />
                  <label class="form-check-label" for="flexCheckDefault"> Hasta </label>
                </div>
                <div v-if="filters.showEndDate" class="active-filter">
                  <input type="date" v-model="filters.end_date" @change="callApi" class="form-control" />
                </div>
              </div>
            </div>
            <div class="col-12">
              <!-- ZONA -->
              <FiltroZona v-model:showZona="filters.showZona" v-model:latZona="filters.lat_zona"
                v-model:lonZona="filters.lon_zona" v-model:radZona="filters.rad_zona" checkboxId="showZona"
                @filterChanged="callApi" />
            </div>
            <div class="col-6">
              <!-- NUMERO -->
              <div class="filter-group">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" id="showNumber" v-model="filters.showNumber"
                    @change="callApi" />
                  <label class="form-check-label" for="flexCheckDefault"> Número </label>
                </div>
                <div :hidden="!filters.showNumber" class="form-text">
                  <label class="form-text-label" for="flexTextDefault"> Inicial </label>
                  <input class="form-text-input" type="number" id="init_number" v-model="filters.inicio_rango"
                    @change="callApi" />
                  <label class="form-text-label" for="flexTextDefault"> Final </label>
                  <input class="form-text-input" type="number" id="end_number" v-model="filters.fin_rango"
                    @change="callApi" />
                </div>
              </div>
              <!-- ORIGEN -->
              <!-- <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                                <label class="form-check-label" for="flexCheckDefault">
                                    Origen
                                </label>
                            </div> -->
            </div>

            <div class="col-6">
              <!-- PREDIO -->
              <div class="filter-group">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" id="showPredios" v-model="filters.showPredio"
                    @change="callApi" />
                  <label class="form-check-label" for="flexCheckDefault"> Predio </label>
                </div>
                <div :hidden="!filters.showPredio" v-if="prediosList" class="active-filter">
                  <input class="form-text-input" type="text" placeholder="Buscar predio..." v-model="predioSearch"
                    style="margin-bottom: 4px; width: 100%" />
                  <select class="form-select form-select-sm" aria-label="Predios" v-model="filters.predio_name"
                    @change="callApi">
                    <option v-for="predio in prediosFiltrados" v-bind:key="predio.name">
                      {{ predio.name }}
                    </option>
                  </select>
                  <label class="form-text-label" for="end_number"> Radio </label>
                  <input class="form-number-input" type="number" id="end_number" v-model="filters.predio_rad"
                    @change="callApi" />
                </div>
              </div>
            </div>

            <!-- </div> -->

            <!-- BOTONES MOSTRAR/OCULTAR -->
          </div>
        </div>

        <!-- FIN FILTROS -->

        <!-- INICIO TABLA -->

        <div class="row tbl-container">
          <div class="table-wrapper">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th>Visible</th>
                  <th>Evento</th>
                  <th>Descripción</th>
                  <th>UTC</th>
                  <th>Tipo</th>
                  <th>Mision</th>
                  <th>Predio</th>
                  <th>Latitud</th>
                  <th>Longitud</th>
                  <th>Estado</th>
                  <th>Alcance</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="evt in events" :key="evt.event_id"
                  :class="{ 'selected-row': selectedEventId === evt.event_id }" @click="toggleRowSelection(evt)">
                  <td>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" v-model="evt.user_visible" :true-value="1"
                        :false-value="0" :key="evt.event_id" />
                    </div>
                  </td>
                  <td>{{ evt.event_unit + evt.event_number }}</td>
                  <td>{{ evt.description }}</td>
                  <td>{{ evt.utc }}</td>
                  <td>{{ evt.type }}</td>
                  <td>{{ evt.mission }}</td>
                  <td>0</td>
                  <td>{{ evt.location.coordinates[1] }}</td>
                  <td>{{ evt.location.coordinates[0] }}</td>
                  <td>{{ evt.state }}</td>
                  <td>{{ evt.scope }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
  <!-- FIN EVENT LIST -->
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import BaseModal from './base/BaseModal.vue'
import FiltroZona from './base/FiltroZona.vue'
import { useServicesStore } from '@/stores/services'
import { useGlobalStore } from '@/stores/global'
import { storeToRefs } from 'pinia'
import type { EventsFilter, EventVisibilityRecord } from '../types'
import api from '@/services'
import { useAuthStore } from '../stores/t-auth'

// Definiciones de variables y referencias
const auth = useAuthStore()

const serv = useServicesStore()
const { eventTypes, events, prediosList } = storeToRefs(serv)

const globalStore = useGlobalStore()
const { filters } = storeToRefs(globalStore)

const emit = defineEmits(['closed', 'rowSelected', 'minimize', 'restore'])

const selectedEventId = ref<number | null>(null)

// Variables reactivas
const showFilters = ref(false) // Controla la visibilidad de filter-box
const predioSearch = ref('')
const baseModalRef = ref()

// Expone la función restoreModal para que App.vue pueda llamarla
defineExpose({
  restoreModal: () => {
    if (baseModalRef.value) {
      baseModalRef.value.restoreModal()
    }
  }
})
// Definiciones de funciones
function closeDialog() {
  guardarVisibilidadEventos()
  emit('closed')
}
function toggleRowSelection(evt: any) {
  if (selectedEventId.value === evt.event_id) {
    // Si ya está seleccionada, deselecciona
    selectedEventId.value = null
  } else {
    // Selecciona la fila y emite las coordenadas
    selectedEventId.value = evt.event_id
    emit('rowSelected', evt.location.coordinates)
  }
}
function toggleAll(valor: number) {
  events.value.forEach((evt) => {
    evt.user_visible = valor
  })
}

// Función para alternar la visibilidad de los filtros
function toggleFilters() {
  showFilters.value = !showFilters.value
}

async function guardarVisibilidadEventos() {
  // Prepara los records a partir de los eventos actuales
  const records: EventVisibilityRecord[] = events.value
    .map((evt) => ({
      user_id: auth.logedUser,
      event_number: parseInt(evt.event_number.toString()), // Convertir a número
      event_unit: evt.event_unit,
      user_visible: evt.user_visible === 1 ? 1 : 0
    }))

  if (records.length === 0) {
    return
  }

  try {
    await api.updateEventsVisibility(records)
    // Opcional: feedback al usuario
    // alert('Visibilidad actualizada correctamente')
  } catch (error) {
    console.error('Error actualizando visibilidad de eventos:', error)
    // Opcional: feedback de error
  }
}

function handleGenericDateChange(event: Event) {
  const value = (event.target as HTMLSelectElement).value
  const today = new Date()
  let startDate = ''
  let endDate = today.toISOString().slice(0, 10) // formato YYYY-MM-DD

  switch (value) {
    case '1': // Hoy
      startDate = endDate
      break
    case '2': // Este mes
      startDate = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().slice(0, 10)
      break
    case '3': // Este año
      startDate = new Date(today.getFullYear(), 0, 1).toISOString().slice(0, 10)
      break
    case '4': // Últimos 7 días
      startDate = new Date(today.getTime() - 6 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
      break
    case '5': // Últimos 15 días
      startDate = new Date(today.getTime() - 14 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
      break
    case '6': // Últimos 30 días
      startDate = new Date(today.getTime() - 29 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
      break
    default:
      // Siempre: limpiar fechas y ocultar
      filters.value.showStartDate = false
      filters.value.showEndDate = false
      filters.value.start_date = ''
      filters.value.end_date = ''
      callApi()
      return
  }

  filters.value.showStartDate = true
  filters.value.showEndDate = true
  filters.value.start_date = startDate
  filters.value.end_date = endDate
  callApi()
}
async function callApi() {
  await guardarVisibilidadEventos()
  const tmpFilter = filters.value
  const filtros: EventsFilter = {
    visible: tmpFilter.visible === '0' ? '' : '1',
    state: tmpFilter.showState ? tmpFilter.state : '',
    scope: tmpFilter.showScope ? tmpFilter.scope : '',
    type: tmpFilter.showType ? tmpFilter.type : '',
    start_date: tmpFilter.showStartDate ? tmpFilter.start_date.replace(/-/g, '') : '',
    end_date: tmpFilter.showEndDate ? tmpFilter.end_date.replace(/-/g, '') : '',
    lat_zona: tmpFilter.showZona ? tmpFilter.lat_zona : '',
    lon_zona: tmpFilter.showZona ? tmpFilter.lon_zona : '',
    rad_zona: tmpFilter.showZona ? tmpFilter.rad_zona : '',
    predio_name: tmpFilter.showPredio ? tmpFilter.predio_name : '',
    predio_rad: tmpFilter.showPredio ? tmpFilter.predio_rad : '',
    inicio_rango: tmpFilter.showNumber ? tmpFilter.inicio_rango : '',
    fin_rango: tmpFilter.showNumber ? tmpFilter.fin_rango : ''
  }

  await serv.dispatchGetEvents(filtros)
}
const prediosFiltrados = computed(
  () =>
    prediosList.value?.filter((predio) =>
      predio.name.toLowerCase().includes(predioSearch.value.toLowerCase())
    ) || []
)
// Hooks de ciclo de vida
onMounted(() => {
  // callApi()
})
</script>

<style scoped>
.selected-row {
  background-color: rgba(255, 255, 255, 0.2);
  /* Fondo blanco semitransparente */
  color: white;
  /* Letras blancas */
}

.selected-row:hover {
  background-color: rgba(255, 255, 255, 0.3);
  /* Fondo más claro al pasar el mouse */
}

table> :not(caption)>*>* {
  background-color: #00000000;
  color: #ffffff;
  font-size: 12px;
  max-height: 100%;
}

div#buscador2 {
  top: 0;
  left: 0;
  width: 100%;
  z-index: 20;
}

span.closeCampos.close {
  height: 25px;
  line-height: 9px;
  background-color: #6c757d;
  padding: 6px;
  border-radius: 5px;
}

label {
  display: contents;
}

.table {
  width: 100%;
  max-width: 100%;
  table-layout: auto;
}

.btn {
  margin-bottom: 0.45rem;
  margin-left: 10px;
}

.filter-box .form-check {
  display: inline-block;
  width: auto;
  margin-right: 10px;
  min-height: fit-content;
}

.row {
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  max-width: 100%;
  margin: 10px;
  padding: 5px;
}

.modal-container {
  max-width: 860px;
  min-width: 500px;
  width: 780px;
  height: 480px;
  min-height: 400px;
}

tbody {
  max-height: 100%;
  overflow-y: scroll;
}

.tbl-container {
  border: 0px solid white;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.1);
  padding: 5px;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  height: calc(100% - 40px);
}

.table-wrapper {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow-x: scroll;
  overflow-y: auto;
  /* Asegura el scroll vertical */
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead {
  position: sticky;
  top: 0;
  /* Fija el encabezado en la parte superior */
  z-index: 1;
  /* Asegura que el encabezado esté por encima del contenido */
  background-color: rgb(74, 74, 74);
  /* Fondo para diferenciarlo */
  color: white;
  /* Color del texto */
}

.container-fluid {
  padding: 0;
  margin: 0;
  max-height: 100%;
}

.form,
.container-fluid {
  height: 100%;
}

.filter-box {
  border: 0px solid white;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.1);
  font-size: 12px;
  padding: 5px;
  margin: 0;
}

.fltr-btn {
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.events-window {
  margin: 0px 10px;
  margin-top: 0px;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  width: 100%;
  height: max-content;
}

.form-control {
  font-size: 12px;
  padding: 2px 10px;
}

.filter-group {
  margin-bottom: 10px;
  margin-top: 5px;
  margin-right: 10px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 5px;
  padding-left: 5px;
  padding-right: 5px;
  font-size: 12px;
  overflow: hidden;
}

.active-filter {
  padding: 2px;
  border: 1px solid #6c757d;
  /* Borde azul */
  border-radius: 10px;
}

input.form-text-input {
  border-radius: 5px;
}

input.form-number-input {
  border-radius: 5px;
  display: inline-block;
}

label.form-text-label {
  font-size: 12px;
  padding: 0px 2px;
  display: inline-block;
  margin-left: 10px;
}

.form-select {
  font-size: 12px;
  padding: 0px 2px;
  display: inline-block;
}

select.form-control {
  padding: 0px;
}

select.form-select {
  display: inline-block;
  width: auto;
  width: 100%;
}

select.select-tiempo {
  display: inline-block;
  width: auto;
}

h5 {
  margin-bottom: 5px;
  height: min-content;
  margin-left: 15px;
  font-size: 16px;
}

.col-3,
.col-12,
.col-9,
.col-6 {
  height: max-content;
  padding: 0px 5px;
}

.bi-caret-down-fill,
.bi-caret-up-fill {
  font-size: 12px;
  margin-right: 5px;
}

.filters-show {
  text-decoration: underline;
  margin-top: 10px;
}

.filters-show:hover {
  color: #6c757d;
  text-decoration: none;
  cursor: pointer;
}

input,
.form-select label {
  max-width: 100%;
}

.form h5 {
  text-align: left;
  margin-left: 0;
}

.col-6.ml-0 {
  padding-left: 0px;
}

.align-end {
  text-align: end;
}

.no-padding {
  padding: 0px;
}

div.col-9.align-end.no-padding button {
  margin-left: 10px;
  margin-right: 0;
}

@media (max-width: 576px) {
  .modal-container {
    max-width: 90vw;
    min-width: 200px;
    width: 90vw;
    height: 480px;
    min-height: 400px;
  }
}
</style>